import { TrashCanPrimaryIcon } from '@assets/iconComponents';
import {
  AdminMenuTop,
  AdminNavigation,
  GuideModal,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderItem,
  TableRow,
  TableWrapper,
  Text
} from '@components';
import { AdminModalType, styleConstant, UserRoleEnum } from '@constant';
import { useAdminUserList } from '@hooks';
import { Button } from '@mui/material';
import { getEnumKeyByValue } from '@utils';

const UserListPage = () => {
  const {
    handleCreateButtonClick,
    handleTableRowClick,

    tableHeader,
    response,
    page,
    handlePageChange,

    checkPermission,

    modalType,
    isModalVisible,
    handleDeleteButtonClick,
    handleDeleteModalClose,
    handleDeleteModalConfirmClick,
    isDeleteUserPending
  } = useAdminUserList();

  const createModalTitle = () => {
    if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '회원정보를 삭제하시겠습니까?';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return '회원정보 삭제에 실패했습니다.';
    } else {
      return '';
    }
  };

  const createModalContent = () => {
    if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '회원정보는 복구할 수 없습니다.';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return '요청이 실패하였습니다. 다시 시도해주세요.';
    } else {
      return '';
    }
  };

  const createModalButtonText = () => {
    if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return '삭제하기';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return '확인';
    } else {
      return '삭제하기';
    }
  };

  const createModalButtonVariant = () => {
    if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return 'contained';
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return 'outlined';
    } else {
      return 'contained';
    }
  };

  const createModalButtonCount = () => {
    if (modalType === AdminModalType.USER_DELETE_CONFIRM) {
      return 2;
    } else if (modalType === AdminModalType.USER_DELETE_FAIL) {
      return 1;
    } else {
      return 2;
    }
  };

  return (
    <>
      <AdminMenuTop />

      <div style={{ display: 'flex' }}>
        <AdminNavigation />

        <div
          className="hide-scrollbar"
          style={{
            width: '100%',
            height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
            padding: '48px 40px 96px 40px',
            overflowY: 'auto'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '40px'
            }}
          >
            <Text variant="h2" fontWeight="bold">
              회원관리
            </Text>
            <Button onClick={handleCreateButtonClick} variant="contained" color="primary">
              회원 등록
            </Button>
          </div>

          <TableWrapper width="100%">
            <Table width="100%">
              <TableHeader>
                {tableHeader.map((header, key) => (
                  <TableHeaderItem key={key} width={header.width}>
                    <Text color="white" fontWeight="bold" align="center">
                      {header.label}
                    </Text>
                  </TableHeaderItem>
                ))}
              </TableHeader>
              <TableBody>
                {response?.data && response?.data.length > 0
                  ? response.data.map((row, key) => (
                      <TableRow
                        key={key}
                        onClick={() => {
                          if (checkPermission('rowClick', row.role as UserRoleEnum)) {
                            handleTableRowClick(row.id);
                          }
                        }}
                        style={{
                          cursor: checkPermission('rowClick', row.role as UserRoleEnum) ? 'pointer' : 'default'
                        }}
                      >
                        <TableCell width={tableHeader[0].width} justifyContent="flex-start" alignItems="flex-start">
                          <Text align="left">{row.name}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[1].width} justifyContent="flex-start" alignItems="flex-start">
                          <Text align="left">{row.email}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[2].width} justifyContent="flex-start" alignItems="flex-start">
                          <Text align="left">{row.contact}</Text>
                        </TableCell>
                        <TableCell width={tableHeader[3].width}>
                          <div>
                            {row.userIps.map((item, index) => (
                              <div key={index} style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                <div
                                  style={{
                                    width: 100,
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <Text
                                    variant="body1"
                                    fontWeight="bold"
                                    style={{
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    {item.nickname}
                                  </Text>
                                </div>
                                <Text align="left" style={{ width: 198 }}>
                                  {item.ip}
                                </Text>
                              </div>
                            ))}
                          </div>
                        </TableCell>
                        <TableCell width={tableHeader[4].width} alignItems="flex-start">
                          <Text>{getEnumKeyByValue(UserRoleEnum, row.role)}</Text>
                        </TableCell>
                        <TableCell
                          width={tableHeader[5].width}
                          alignItems="flex-start"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          style={{ cursor: 'default' }}
                        >
                          {checkPermission('delete', row.role as UserRoleEnum) && (
                            <TrashCanPrimaryIcon
                              onClick={() => {
                                handleDeleteButtonClick(row.id);
                              }}
                              style={{ width: 20, height: 20, cursor: 'pointer' }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  : []}
              </TableBody>
            </Table>
          </TableWrapper>

          <div
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: 8, alignItems: 'center' }}>
              <Text variant="body1">Total</Text>
              <Text variant="subtitle" fontWeight="bold">
                {response?.meta?.itemCount ?? 0}
              </Text>
            </div>
            <Pagination page={page} pageCount={response?.meta?.pageCount ?? 0} onChange={handlePageChange} />
          </div>
        </div>
      </div>

      <GuideModal
        isVisible={isModalVisible}
        onClick={handleDeleteModalConfirmClick}
        onClose={handleDeleteModalClose}
        title={createModalTitle()}
        content={createModalContent()}
        buttonText={createModalButtonText()}
        buttonVariant={createModalButtonVariant()}
        buttonCount={createModalButtonCount()}
        isPending={isDeleteUserPending}
      />
    </>
  );
};

export default UserListPage;
